import React from 'react'
import './CertificateComponent.css'
import FooterComponent from '../Footer/FooterComponent'
import HeaderComponent from '../Header/HeaderComponent'
import CertificatesFunctionComponent from './CertificatesFunctionComponent'

const CertificateComponent = () => {
  const country = sessionStorage.getItem('country');
  const name = sessionStorage.getItem('name');
  const lastName = sessionStorage.getItem('last_name');

  return (
    <div className='flex flex-col min-h-screen container-innovador'>
      <HeaderComponent />

      <div className='flex-grow w-full h-full'>
        <div className="flex justify-center mt-5">
          <div className="flex w-full max-w-4xl flex-col md:flex-row items-center">
            {/* Texto y certificado */}
            <div className="md:flex-grow md:flex-1 px-4 py-2 rounded-lg mx-3 mb-3 md:mb-0 flex items-center justify-center md:justify-start md:items-start">
              <div>
                <h2 className="text-center md:text-left font-bold text-[#011965] mt-5 fs-2">¡Gracias por asistir!</h2>
                <h3 className="text-center md:text-left text-lg mt-3 fs-4" style={{ fontFamily: 'sans-serif' }}>
                  Podrá descargar el <strong>certificado</strong> una vez haya <strong>completado su</strong> <strong>participación</strong> en el curso.
                </h3>
                <CertificatesFunctionComponent country={country} name={name} lastName={lastName} />
              </div>
            </div>
            {/* Imagen del certificado */}
            <div className="md:flex-grow md:flex-1 px-4 py-2 rounded-lg mx-3 mb-3 md:mb-0 flex items-center justify-center">
              <img src="imagen_certificado.png" alt="certificado" className="max-w-full h-auto" />
            </div>
          </div>
        </div>
      </div>

      <FooterComponent />
    </div>
  )
}

export default CertificateComponent
